import { createContext } from 'react';
import { initialState as chatContextState } from './reducer';
import { ChatContextType } from './types';

export const defaultContext = {
  chatContextState,
  dispatchChatContextAction: () => {},
};

export const ChatContext = createContext<ChatContextType>(defaultContext);
